/**
 * @module app.VectorSynchronizer
 */
import olcsVectorSynchronizer from 'ol-cesium/src/olcs/VectorSynchronizer.ts';


class VectorSynchronizer extends olcsVectorSynchronizer {

  constructor(map, scene, featureConverter) {
    super(map, scene, featureConverter);
  }

  createSingleLayerCounterparts(olLayerWithParents) {
    const ignore = /** @type {boolean} */ (olLayerWithParents.layer.get('cesiumIgnore'));
    if (!ignore) {
      return super.createSingleLayerCounterparts(olLayerWithParents);
    } else {
      return null;
    }
  }
}


export default VectorSynchronizer;
